import { render, staticRenderFns } from "./FifaGroupView.vue?vue&type=template&id=3c98a5c4&scoped=true&"
import script from "./FifaGroupView.vue?vue&type=script&lang=js&"
export * from "./FifaGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98a5c4",
  null
  
)

export default component.exports